<template>
    <van-popup
        v-model="showPop"
        closeable
        close-icon="https://file.40017.cn/appresource/image/forStudent/new/icon_closed@2x.png"
        round
        position="bottom"
        :class="['rule-popup-box', {'no-btn': !isShowBtn}]"
        @close="closePop">
        <div class="title-popup">{{title}}</div>
        <div class="cont-box" v-html="content"></div>
        <div class="btn-box" v-if="isShowBtn">
            <button v-if="isShowEmptyBtn" class="btn btn-empty" @click="closePopUp">我知道了</button>
            <button v-if="isShowfillBtn" class="btn" @click="goUnlock">解锁权益</button>
        </div>
    </van-popup>
</template>

<script>
import { Popup, Toast, Icon } from 'vant';

export default {
    name: 'rulePopup',
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        isShowBtn: {
            type: Boolean,
            default: false
        },
        isShowEmptyBtn: {
            type: Boolean,
            default: true
        },
        isShowfillBtn: {
            type: Boolean,
            default: true
        }
    },
    components: {
        [Popup.name]: Popup,
        [Icon.name]: Icon
    },
    data() {
        return {
            showPop: false
        }
    },
    methods: {
        show() {
            this.showPop = true
        },
        closePopUp() {
            this.showPop = false
            this.$emit('setTrack', {
                action: 'students_rightsfloat_button_click',
                label: '学生会员权益浮层按钮点击',
                value: {"channel":"学生专区","scene":"公共","rights": this.title,"site":"我知道了"}
            })
        },
        goUnlock() {
            this.closePopUp()
            this.$emit('setTrack', {
                action: 'students_rightsfloat_button_click',
                label: '学生会员权益浮层按钮点击',
                value: {"channel":"学生专区","scene":"公共","rights": this.title,"site":"解锁权益"}
            })
            //去学籍认证页面，返回后刷新页面，需要显示成功弹窗
            sessionStorage.setItem('gotoStudentChsiAuth', 1)
            // 测试环境：https://wx.qa.17u.cn/memberft/student/studentcard/studentAuth?channelcode=3e5e56bc5665477bae5620ad22d878bb&certificationSource=1&refid=123
            // 线上环境：https://wx.17u.cn/memberft/student/studentcard/studentAuth?channelcode=4da9db38ad494cb98f4e5efe15ef8eec&certificationSource=1&refid=123
            const AuthUrl = process.env.VUE_APP_ENV === 'production' 
            ? 'tctclient://web/share?type=wxMiniProgram&wxUserName=gh_0a00573ff7cf&wxPath=%2Fpage%2Fhome%2Fwebview%2Fwebview%3Fsrc%3Dhttps%253A%252F%252Fwx.17u.cn%252Fmemberft%252Fstudent%252Fstudentcard%252FstudentAuth%253Fchannelcode%253D4da9db38ad494cb98f4e5efe15ef8eec%2526certificationSource%253D1%2526refid%253D2000025136'
            : 'tctclient://web/share?type=wxMiniProgram&wxUserName=gh_0a00573ff7cf&wxPath=%2Fpage%2Fhome%2Fwebview%2Fwebview%3Fsrc%3Dhttps%253A%252F%252Fwx.qa.17u.cn%252Fmemberft%252Fstudent%252Fstudentcard%252FstudentAuth%253Fchannelcode%253D3e5e56bc5665477bae5620ad22d878bb%2526certificationSource%253D1%2526refid%253D123'
            location.href = AuthUrl
        },
        closePop() {
            this.showPop = false
            this.$emit('setTrack', {
                action: 'students_rightsfloat_click',
                label: '学生会员权益浮层关闭',
                value: {"channel":"学生专区","scene":"公共","rights": this.title}
            })
        }
    }

}
</script>

<style lang="less" scoped>
.rule-popup-box {
    background-image: linear-gradient(180deg, #D9FFEB 0%, #FFFFFF 15%);
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    &.no-btn {
        .cont-box {
            max-height: 299px;
        }
    }
    ::v-deep .van-popup__close-icon {
        position: absolute;
        .van-icon__image {
            width: 24px;
            height: 24px;
        }
    }
    .title-popup {
        text-align: center;
        line-height: 28px;
        font-size: 19px;
        color: #333333;
        padding-top: 16px;
        font-weight: 600;
    }
    .cont-box {
        margin: 12px 24px 24px;
        color: #333333;
        font-size: 14px;
        line-height: 1.5;
        max-height: 214px;
        overflow: auto;
        text-align: justify;
    }
    .btn-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 20px;
        .btn {
            min-width: 210px;
            max-width: 291px;
            flex: 1;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            // border: 1px solid #06C584;
            border-radius: 22px;
            padding: 11px;
            margin: 0 4px;
            background-image: linear-gradient(90deg, #01E36D 0%, #06C584 100%);
            &.btn-empty {
                min-width: 108px;
                color: #06C584;
                border: 1px solid #06C584;
                background: #fff;
            }
        }
    }
}
</style>>
